import { useTranslation } from 'react-i18next'
import { getUpsellWallColumns, type UpsellWall } from '../../upsellWall'
import { UpsellWallTile } from './UpsellWallTile'
import * as S from './UpsellWallPreview.styles'

type UpsellWallPreviewProps = {
  wall: UpsellWall
  excludedTileIndexes: ReadonlySet<number>
  onTileToggle: (tileIndex: number) => void
}

export function UpsellWallPreview({
  wall,
  excludedTileIndexes,
  onTileToggle,
}: UpsellWallPreviewProps) {
  const { t } = useTranslation()
  const columnsCount = getUpsellWallColumns(wall.photos.length)
  const tilesGridStyle: React.CSSProperties & {
    '--wall-columns': number
    '--wall-rows': number
  } = {
    '--wall-columns': columnsCount,
    '--wall-rows': Math.ceil(wall.photos.length / columnsCount),
  }
  // Turning off a wall's only tile would leave nothing to add.
  const canToggleTiles = wall.photos.length > 1
  return (
    <S.WallScene>
      <S.TilesGrid style={tilesGridStyle} data-testid="upsell-wall-tiles">
        {wall.photos.map((photo, tileIndex) => {
          if (!canToggleTiles) {
            return (
              <S.TileSlot key={tileIndex}>
                <UpsellWallTile
                  tileStyle={wall.tileStyle}
                  photo={photo}
                  isTurnedOff={false}
                />
              </S.TileSlot>
            )
          }
          const isTurnedOff = excludedTileIndexes.has(tileIndex)
          return (
            <S.TileToggleSlot
              key={tileIndex}
              type="button"
              aria-pressed={!isTurnedOff}
              aria-label={t('cart_upsells.wall_tile', {
                position: tileIndex + 1,
              })}
              onClick={() => onTileToggle(tileIndex)}
              data-testid="upsell-wall-tile"
            >
              <UpsellWallTile
                tileStyle={wall.tileStyle}
                photo={photo}
                isTurnedOff={isTurnedOff}
              />
              <S.ToggleIcon aria-hidden>
                <S.ToggleBar />
                <S.ToggleCrossBar />
              </S.ToggleIcon>
            </S.TileToggleSlot>
          )
        })}
      </S.TilesGrid>
    </S.WallScene>
  )
}
